var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCasinoChip = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31598_96211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0.5625C6.37374 0.5625 0.5625 6.37361 0.5625 13.5C0.5625 20.6372 6.37374 26.4375 13.5 26.4375C20.6373 26.4375 26.4375 20.6372 26.4375 13.5C26.4375 6.37361 20.6373 0.5625 13.5 0.5625ZM19.8935 12.9286L17.295 14.8153L18.2868 17.8664C18.47 18.4593 18.2652 19.0955 17.7693 19.4513C17.2734 19.8178 16.5943 19.8178 16.0984 19.4513L13.5 17.5646L10.9126 19.4513C10.3823 19.8265 9.74592 19.8235 9.24119 19.4513C8.7453 19.0955 8.52999 18.4593 8.72372 17.8664L9.71603 14.8153L7.11758 12.9286C6.62169 12.562 6.41691 11.9259 6.6001 11.3437C6.79436 10.7616 7.33342 10.3627 7.94776 10.3627H11.1606L12.1523 7.31157C12.3466 6.71862 12.8857 6.33044 13.5 6.33044H13.5111C14.1254 6.33044 14.6645 6.71862 14.8587 7.31157L15.8505 10.3627H19.0522C19.6776 10.3627 20.2167 10.7616 20.4109 11.3437C20.5941 11.9259 20.3894 12.562 19.8935 12.9286Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31598_96211"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCasinoChip);
export default ForwardRef;